import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import ProductCard from "@/components/woocommerce/ProductCard"
import { Caret } from "@/common/icons/caret"
import { pushDataLayer, getProductResponse } from "@/lib/helpers/tagManager"
import Block from "@/components/wrappers/block"
import classNames from "classnames"

const ProductArchive = ({ block }) => {
  const { products, textColorOnTabs } = block.attrs
  const router = useRouter()
  const useSorting = false // Used to disable sorting until we have working copy/UX design

  useEffect(() => {
    pushDataLayer(
      {
        event: "view_item_list",
        ecommerce: { items: getProductResponse(products) }
      },
      true
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  let slug = "allt"
  let baseSlug

  if (router.query.slug !== undefined) {
    slug = router.query.slug[1] ? router.query.slug[1] : "allt"
    baseSlug = router.query.slug[0]
  }

  const [currentTagSlug, setCurrentTagSlug] = useState(slug)
  const [tags, setTags] = useState([
    {
      id: 0,
      name: "Allt",
      slug: "allt"
    }
  ])

  const [sortBy, setSortBy] = useState("editorial")

  useEffect(() => {
    products.map((product) => {
      if (
        product.tags.length !== 0 &&
        !tags.some((tag) => tag.id === product.tags[0].id)
      ) {
        setTags([...tags, product.tags[0]])
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags])

  useEffect(() => {
    router.beforePopState(({ as }) => {
      const slugs = as.replace(/^\/|\/$/g, "").split("/")
      setCurrentTagSlug(slugs[1] ? slugs[1] : "allt")
      return true
    })
  }, [router])

  function updateCurrentTag(tag) {
    setCurrentTagSlug(tag.slug)
    router.push(
      {
        pathname: "/" + baseSlug + "/" + (tag.slug == "allt" ? "" : tag.slug)
      },
      undefined,
      { shallow: true }
    )
  }

  function updateCurrentTagBySlug(tagSlug) {
    updateCurrentTag(tags.find((x) => x.slug === tagSlug))
  }

  function changeSort(sortType) {
    setSortBy(sortType)
  }

  function sortProducts(a, b) {
    switch (sortBy) {
      case "editorial":
        return a.sorting > b.sorting ? 1 : -1
      case "priceFalling":
        return a.prices.price < b.prices.price ? 1 : -1
      case "priceRicing":
        return a.prices.price > b.prices.price ? 1 : -1
      case "alphabeticalFalling":
        return a.name < b.name ? 1 : -1
      case "alphabeticalRicing":
        return a.name > b.name ? 1 : -1
      default:
        return true
    }
  }

  const productCards = products.sort(sortProducts).map((product) => {
    if (product.tags[0]?.slug === currentTagSlug || currentTagSlug === "allt") {
      return <ProductCard key={product.id} product={product} />
    }
  })

  if (!products || products.length === 0) {
    return (
      <Block block={block}>
        <div className="text-center">Inga produkter hittades.</div>
      </Block>
    )
  }

  return (
    <Block block={block}>
      <div className="flex mb-8">
        {tags.map((tag) => {
          return (
            <button
              className={
                tag.slug == currentTagSlug
                  ? classNames(
                      "py-4 font-bold active px-6 border-b-2 border-black hidden md:flex",
                      textColorOnTabs
                    )
                  : classNames(
                      "py-4 px-6 border-b border-black-25 text-gray-60 hidden md:flex",
                      textColorOnTabs
                    )
              }
              key={tag.id}
              aria-label={tag.name}
              onClick={() => {
                updateCurrentTag(tag)
              }}>
              {tag.name}
            </button>
          )
        })}
        <div className="relative w-full md:hidden">
          <select
            className="block w-full py-4 pl-4 pr-8 bg-white rounded appearance-none text-bold text-color-black focus:outline-none focus:shadow-outline md:hidden"
            value={currentTagSlug}
            onChange={(val) => updateCurrentTagBySlug(val.target.value)}>
            {tags.map((tag) => {
              return (
                <option key={tag.slug} value={tag.slug}>
                  {tag.name}
                </option>
              )
            })}
          </select>
          <Caret className="absolute w-[11px] h-auto mt-5 mr-4 pointer-events-none fill-current right-2 top-1 md:hidden" />
        </div>
        <div className="relative flex-1 hidden border-b border-black-25 md:flex"></div>
        {useSorting && (
          <div className="relative hidden border-b border-black-25 md:flex">
            <select
              className="hidden w-full py-2 pl-4 pr-10 bg-transparent rounded appearance-none text-bold text-color-black focus:outline-none focus:shadow-outline lg:flex"
              onChange={(val) => changeSort(val.target.value)}>
              <option value="editorial">Redaktionell</option>
              <option value="alphabeticalRicing">Alfabetisk</option>
              <option value="priceFalling">Pris, fallande</option>
              <option value="priceRicing">Pris, stigande</option>
            </select>
            <Caret className="absolute w-[11px] hidden mt-6 mr-4 pointer-events-none fill-current right-2 top-1 lg:flex" />
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 gap-4 gap-y-12 md:gap-8 md:gap-y-10 lg:gap-10 md:grid-cols-2 xl:grid-cols-3">
        {productCards}
      </div>
    </Block>
  )
}

export default ProductArchive
